module.exports = `[data-mode="sunset"] {
  --commonColorTransparent: transparent;
  --commonColorWhite: #ffffff;
  --commonColorBlack: #000000;
  --commonDimensionContainerNarrow: 50rem;
  --commonDimensionContainer: 75rem;
  --commonDimensionContainerWide: 100rem;
  --commonDimensionBreakpointXs: 0;
  --commonDimensionBreakpointMini: 240px;
  --commonDimensionBreakpointSm: 480px;
  --commonDimensionBreakpointMd: 640px;
  --commonDimensionBreakpointLg: 800px;
  --commonDimensionBreakpointXl: 960px;
  --commonDimensionBreakpointXxl: 1200px;
  --commonDimensionBreakpointXxxl: 1600px;
  --commonDimensionSpacing0: 0;
  --commonDimensionSpacing1: 0.25rem;
  --commonDimensionSpacing2: 0.5rem;
  --commonDimensionSpacing3: 0.75rem;
  --commonDimensionSpacing4: 1rem;
  --commonDimensionSpacing5: 1.5rem;
  --commonDimensionSpacing6: 2rem;
  --commonDimensionSpacing7: 3rem;
  --commonDimensionSpacing8: 4rem;
  --commonDimensionSpacing9: 6rem;
  --commonDimensionSpacing10: 8rem;
  --alertColorBgSuccess: #effceb;
  --alertColorBgError: #fceeeb;
  --alertColorBgWarning: #fef0cb;
  --alertColorBgInfo: #ebf1f8;
  --buttonColorBgPrimary: #144a38;
  --buttonColorBgPrimaryHover: #144a38;
  --buttonColorBgPrimaryActive: #13362a;
  --buttonColorBgPrimaryDisabled: rgba(20, 74, 56, 0.4);
  --buttonColorBgSecondary: transparent;
  --buttonColorBgSecondaryHover: transparent;
  --buttonColorBgSecondaryActive: transparent;
  --buttonColorBgSecondaryDisabled: transparent;
  --buttonColorBgTertiary: transparent;
  --buttonColorBgTertiaryHover: transparent;
  --buttonColorBgTertiaryActive: transparent;
  --buttonColorBgTertiaryDisabled: transparent;
  --buttonColorBgDestructive: transparent;
  --buttonColorBgDestructiveHover: transparent;
  --buttonColorBgDestructiveActive: transparent;
  --buttonColorBgDestructiveDisabled: transparent;
  --buttonColorFgPrimary: #f8f8f8;
  --buttonColorFgPrimaryHover: #82e578;
  --buttonColorFgPrimaryActive: #f8f8f8;
  --buttonColorFgPrimaryDisabled: rgba(248, 248, 248, 0.4);
  --buttonColorFgSecondary: #144a38;
  --buttonColorFgSecondaryHover: #122a21;
  --buttonColorFgSecondaryActive: #262626;
  --buttonColorFgSecondaryDisabled: #b9b9b9;
  --buttonColorFgTertiary: #144a38;
  --buttonColorFgTertiaryHover: #122a21;
  --buttonColorFgTertiaryActive: #262626;
  --buttonColorFgTertiaryDisabled: #b9b9b9;
  --buttonColorFgDestructive: #75160f;
  --buttonColorFgDestructiveHover: #5e160e;
  --buttonColorFgDestructiveActive: #331108;
  --buttonColorFgDestructiveDisabled: #b9b9b9;
  --buttonColorBorderPrimary: transparent;
  --buttonColorBorderPrimaryHover: transparent;
  --buttonColorBorderPrimaryActive: transparent;
  --buttonColorBorderPrimaryDisabled: transparent;
  --buttonColorBorderSecondary: #144a38;
  --buttonColorBorderSecondaryHover: #122a21;
  --buttonColorBorderSecondaryActive: #262626;
  --buttonColorBorderSecondaryDisabled: #b9b9b9;
  --buttonColorBorderTertiary: transparent;
  --buttonColorBorderTertiaryHover: transparent;
  --buttonColorBorderTertiaryActive: transparent;
  --buttonColorBorderTertiaryDisabled: transparent;
  --buttonColorBorderDestructive: #75160f;
  --buttonColorBorderDestructiveHover: #5e160e;
  --buttonColorBorderDestructiveActive: #331108;
  --buttonColorBorderDestructiveDisabled: #b9b9b9;
  --buttonDimensionBorderRadius: 9999px;
  --buttonDimensionBorderWidth: 2px;
  --buttonDimensionPaddingHorizontal: 2rem;
  --buttonDimensionPaddingVertical: 1rem;
  --buttonDimensionPaddingGap: 0.5rem;
  --buttonDimensionPaddingSmallHorizontal: 1rem;
  --buttonDimensionPaddingSmallVertical: 0.5rem;
  --buttonDimensionPaddingSmallGap: 0.5rem;
  --buttonDimensionPaddingLargeHorizontal: 2rem;
  --buttonDimensionPaddingLargeVertical: 1rem;
  --buttonDimensionPaddingLargeGap: 0.5rem;
  --buttonTypographyFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --buttonTypographyFontSize: 1rem;
  --buttonTypographyFontWeight: 700;
  --buttonTypographyLineHeight: 1;
  --buttonTypographyLetterSpacing: -0.02em;
  --buttonTypographyTextTransform: none;
  --buttonTypographySmallFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --buttonTypographySmallFontSize: 1rem;
  --buttonTypographySmallFontWeight: 700;
  --buttonTypographySmallLineHeight: 1;
  --buttonTypographySmallLetterSpacing: -0.02em;
  --buttonTypographySmallTextTransform: none;
  --buttonTypographyLargeFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --buttonTypographyLargeFontSize: 1.125rem;
  --buttonTypographyLargeFontWeight: 700;
  --buttonTypographyLargeLineHeight: 1;
  --buttonTypographyLargeLetterSpacing: -0.02em;
  --buttonTypographyLargeTextTransform: none;
  --datePickerColorBgSelected: #144a38;
  --datePickerColorBgSelectedHover: #144a38;
  --datePickerColorBgHover: #f1f1f1;
  --datePickerColorFgSelected: #ffffff;
  --datePickerColorFgSelectedHover: #ffffff;
  --datePickerColorFgHover: #262626;
  --drawerColorBg: #f8f8f8;
  --drawerColorBgTop: #ffffff;
  --drawerColorFgTop: #144a38;
  --drawerColorFgMenu: #144a38;
  --drawerColorFgItem: #262626;
  --drawerColorFgChevron: #474747;
  --drawerColorFgClose: #5e5e5e;
  --drawerColorFgLink: #262626;
  --drawerColorFgLinkHover: #122a21;
  --drawerColorFgLinkPressed: #144a38;
  --drawerColorBorderDivider: #f1f1f1;
  --drawerColorBorderFocus: #373663;
  --drawerColorBorderFocusTop: #373663;
  --footerColorBg: #144a38;
  --footerColorBgAcknowledgement: #101e19;
  --footerColorFg: #ffffff;
  --footerColorFgHeading: #82e578;
  --footerColorFgLink: #ffffff;
  --footerColorFgLinkHover: #bef0ad;
  --footerColorFgLinkPressed: #dff8d6;
  --footerColorFgAcknowledgement: #ffffff;
  --footerColorBorder: #122a21;
  --footerColorBorderFocus: #b9b5d3;
  --footerColorBorderFocusAcknowledgement: #b9b5d3;
  --smallFooterColorBg: #144a38;
  --smallFooterColorFg: #ffffff;
  --smallFooterColorFgLink: #ffffff;
  --smallFooterColorFgLinkHover: #bef0ad;
  --smallFooterColorFgLinkPressed: #dff8d6;
  --smallFooterColorBorderFocus: #b9b5d3;
  --smallFooterMetaAcknowledgementVisible: true;
  --smallFooterMetaAcknowledgementShowImage: true;
  --formControlTypographyLabelFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --formControlTypographyLabelFontSize: 1rem;
  --formControlTypographyLabelFontWeight: 700;
  --formControlTypographyLabelLineHeight: 1.5;
  --formControlTypographyLabelLetterSpacing: -0.02em;
  --formControlTypographyLabelTextTransform: none;
  --formControlTypographyHelpFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --formControlTypographyHelpFontSize: 1rem;
  --formControlTypographyHelpFontWeight: 400;
  --formControlTypographyHelpLineHeight: 1.5;
  --formControlTypographyHelpLetterSpacing: -0.02em;
  --headerColorBgNav: #ffffff;
  --headerColorFgNav: #262626;
  --headerColorFgNavHover: #122a21;
  --headerColorBorderFocusNav: #373663;
  --smallHeaderColorBg: #ffffff;
  --smallHeaderColorBgInvert: #144a38;
  --smallHeaderColorFgMenu: #262626;
  --smallHeaderColorFgMenuInvert: #ffffff;
  --smallHeaderColorFgIcons: #144a38;
  --smallHeaderColorFgIconsInvert: #82e578;
  --smallHeaderColorBorderDivider: #b9b9b9;
  --smallHeaderColorBorderDividerInvert: #122a21;
  --smallHeaderColorBorderFocus: #373663;
  --smallHeaderColorBorderFocusInvert: #b9b5d3;
  --smallHeaderMetaIsDark: false;
  --smallHeaderMetaIsDarkInvert: true;
  --inputColorBg: #f8f8f8;
  --inputColorBorder: #3b3b3b;
  --loaderColorBorderA: #82e578;
  --loaderColorBorderB: #144a38;
  --overlayColorBg: rgba(17, 17, 17, 0.9);
  --productCardColorBgHighlight: #144a38;
  --productCardColorFgHighlight: #82e578;
  --progressStepperColorFgIndicatorActive: #144a38;
  --progressStepperColorFgIndicatorInactive: #b9b9b9;
  --tagColorBg: #262626;
  --tagColorBgProminent: #111111;
  --tagColorBgGentle: #474747;
  --tagColorBgMuted: #5e5e5e;
  --tagColorBgBrand: #82e578;
  --tagColorBgError: #75160f;
  --tagColorBgSuccess: #144a38;
  --tagColorBgWarning: #eaaf18;
  --tagColorBgInfo: #003b77;
  --tagColorFg: #ffffff;
  --tagColorFgProminent: #ffffff;
  --tagColorFgGentle: #ffffff;
  --tagColorFgMuted: #ffffff;
  --tagColorFgBrand: #144a38;
  --tagColorFgError: #ffffff;
  --tagColorFgSuccess: #ffffff;
  --tagColorFgWarning: #262626;
  --tagColorFgInfo: #ffffff;
  --tagTypographyFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --tagTypographyFontSize: 0.875rem;
  --tagTypographyFontWeight: 400;
  --tagTypographyLineHeight: 1;
  --tagTypographyLetterSpacing: -0.02em;
  --tagTypographyTextTransform: none;
  --tooltipColorBg: #262626;
  --tooltipColorFg: #e2e2e2;
  --themeColorBg: #fdd6bc;
  --themeColorBgSurface: #ffede2;
  --themeColorBgSurfaceProminent: #ffffff;
  --themeColorBorder: #b9b9b9;
  --themeColorBorderProminent: #3b3b3b;
  --themeColorBorderGentle: #d4d4d4;
  --themeColorBorderMuted: #f1f1f1;
  --themeColorBorderSelected: #144a38;
  --themeColorBorderSuccess: #144a38;
  --themeColorBorderError: #75160f;
  --themeColorBorderWarning: #eaaf18;
  --themeColorBorderInfo: #003b77;
  --themeColorBorderBrand: #144a38;
  --themeColorBorderFocus: #373663;
  --themeColorBorderProductBasic: #003b77;
  --themeColorBorderProductBronze: #c97f2d;
  --themeColorBorderProductSilver: #86aebe;
  --themeColorBorderProductGold: #c4b355;
  --themeColorBorderProductHospital: #003b77;
  --themeColorBorderProductExtras: #7C3E98;
  --themeColorBorderProductCombined: #144a38;
  --themeColorFg: #262626;
  --themeColorFgProminent: #111111;
  --themeColorFgGentle: #474747;
  --themeColorFgMuted: #5e5e5e;
  --themeColorFgBrand: #144a38;
  --themeColorFgSelected: #144a38;
  --themeColorFgLabel: #144a38;
  --themeColorFgSuccess: #144a38;
  --themeColorFgError: #75160f;
  --themeColorFgWarning: #302405;
  --themeColorFgInfo: #003b77;
  --themeColorFgHeading2xl: #144a38;
  --themeColorFgHeadingXl: #144a38;
  --themeColorFgHeadingLg: #144a38;
  --themeColorFgHeadingMd: #262626;
  --themeColorFgHeadingSm: #262626;
  --themeColorFgHeadingXs: #262626;
  --themeColorFgLink: #144a38;
  --themeColorFgLinkHover: #122a21;
  --themeColorFgLinkActive: #144a38;
  --themeColorFgLinkDisabled: #5e5e5e;
  --themeDimensionBorderRadiusNone: 0;
  --themeDimensionBorderRadiusSmall: 4px;
  --themeDimensionBorderRadiusStandard: 8px;
  --themeDimensionBorderRadiusFull: 9999px;
  --themeDimensionBorderWidthNone: 0;
  --themeDimensionBorderWidthFine: 1px;
  --themeDimensionBorderWidthThin: 2px;
  --themeDimensionBorderWidthMedium: 4px;
  --themeDimensionBorderWidthThick: 8px;
  --themeMetaBrand: nib;
  --themeMetaModeName: sunset;
  --themeMetaIsDark: false;
  --themeTypographyFontFamilyCopy: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyFontFamilyHeading: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyCopyFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyCopyFontSize: 1rem;
  --themeTypographyCopyFontWeight: 400;
  --themeTypographyCopyLineHeight: 1.5;
  --themeTypographyCopyLetterSpacing: -0.02em;
  --themeTypographyCopySmallFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyCopySmallFontSize: 0.875rem;
  --themeTypographyCopySmallFontWeight: 400;
  --themeTypographyCopySmallLineHeight: 1.5;
  --themeTypographyCopySmallLetterSpacing: -0.02em;
  --themeTypographyCopyLargeFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyCopyLargeFontSize: 1.125rem;
  --themeTypographyCopyLargeFontWeight: 400;
  --themeTypographyCopyLargeLineHeight: 1.5;
  --themeTypographyCopyLargeLetterSpacing: -0.02em;
  --themeTypographyCopyBoldFontWeight: 700;
  --themeTypographyLinkFontWeight: 500;
  --themeTypographyHeading2xlFontFamily: 'Grenette Pro', Georgia, serif;
  --themeTypographyHeading2xlFontSize: 3.375rem;
  --themeTypographyHeading2xlFontWeight: 600;
  --themeTypographyHeading2xlLineHeight: 1;
  --themeTypographyHeading2xlLetterSpacing: -0.02em;
  --themeTypographyHeading2xlTextTransform: none;
  --themeTypographyHeadingXlFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyHeadingXlFontSize: 2.25rem;
  --themeTypographyHeadingXlFontWeight: 600;
  --themeTypographyHeadingXlLineHeight: 1;
  --themeTypographyHeadingXlLetterSpacing: -0.02em;
  --themeTypographyHeadingXlTextTransform: none;
  --themeTypographyHeadingLgFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyHeadingLgFontSize: 1.5rem;
  --themeTypographyHeadingLgFontWeight: 600;
  --themeTypographyHeadingLgLineHeight: 1;
  --themeTypographyHeadingLgLetterSpacing: -0.02em;
  --themeTypographyHeadingLgTextTransform: none;
  --themeTypographyHeadingMdFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyHeadingMdFontSize: 1.25rem;
  --themeTypographyHeadingMdFontWeight: 700;
  --themeTypographyHeadingMdLineHeight: 1.2;
  --themeTypographyHeadingMdLetterSpacing: -0.02em;
  --themeTypographyHeadingMdTextTransform: none;
  --themeTypographyHeadingSmFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyHeadingSmFontSize: 1rem;
  --themeTypographyHeadingSmFontWeight: 700;
  --themeTypographyHeadingSmLineHeight: 1.2;
  --themeTypographyHeadingSmLetterSpacing: -0.02em;
  --themeTypographyHeadingSmTextTransform: none;
  --themeTypographyHeadingXsFontFamily: 'Buenos Aires', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --themeTypographyHeadingXsFontSize: 1rem;
  --themeTypographyHeadingXsFontWeight: 700;
  --themeTypographyHeadingXsLineHeight: 1.2;
  --themeTypographyHeadingXsLetterSpacing: -0.02em;
  --themeTypographyHeadingXsTextTransform: none;
}
`;